import { fontAwesomeHtmlStylesGenerator } from 'server/utils/fontAwesomeUtils'

// NOTE: All entities keys of string fields with font awesome icons
export const fieldKeysOfEntitiesWithFontAwesomeSelectors = [
  'closedIconClassName',
  'iconClassName',
  'iconClassNameAfter',
  'iconClassNameBefore',
  'listItemClassName',
]

// NOTE: Use this enum for font awesome icons in publisher. It's for optimization
export enum publisherFontAwesomeIconsEnum {
  ChevronCircleLeftLight = 'fal fa-chevron-circle-left',
  ChevronCircleRightLight = 'fal fa-chevron-circle-right',
  ChevronDownSolid = 'fas fa-chevron-down',
  ChevronLeftSolid = 'fas fa-chevron-left',
  ChevronRightDuotone = 'fad fa-chevron-right',
  ChevronRightSolid = 'fas fa-chevron-right',
  ChevronUpSolid = 'fas fa-chevron-up',
  CircleSolid = 'fas fa-circle',
  ClockRegular = 'far fa-clock',
  EyeRegular = 'far fa-eye',
  EyeSlashRegular = 'far fa-eye-slash',
  Times = 'fa fa-times',
}

const publisherFontAwesomeIconsSelectors = Object.values(
  publisherFontAwesomeIconsEnum,
)

// NOTE: this constant has all font awesome icons selectors for publisher, except ones from entities object
export const publisherFontAwesomeIconsAllSelectors = (() => {
  const result: string[] = []
  publisherFontAwesomeIconsSelectors.forEach(
    classnameOrDescendantCombinationOfClassnames => {
      // NOTE: "classnameOrDescendantCombinationOfClassnames" example: "fa-swap-opacity", "fa-duotone fa-swap-opacity"
      result.push(classnameOrDescendantCombinationOfClassnames)
      classnameOrDescendantCombinationOfClassnames
        .split(' ')
        .forEach(classname => {
          // NOTE: "classname" example: "fa-duotone", "fa-swap-opacity"
          result.push(classname)
        })
    },
  )
  return result
})()

export const publisherFontAwesomeIconsHtmlStyles =
  fontAwesomeHtmlStylesGenerator(publisherFontAwesomeIconsAllSelectors)
